/**
 * @license Codistica
 *
 * Copyright (c) 2020, Codistica and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * BUILD DATE: Fri Jul 10 2020 16:51:08 GMT+0200 (Central European Summer Time)
 */
import _bindInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/bind";
import _newArrowCheck from "@babel/runtime-corejs3/helpers/esm/newArrowCheck";
import _someInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/some";

/** @module react/plugins/input-validators/word-validator */
import { Types } from '@codistica/types';
import { InputValidatorPluginUtils } from '../../../classes/input-validator-plugin-utils.js';
var wordValidatorSchema = new Types({
  options: {
    type: 'Object',
    def: {
      valid: {
        type: 'Array<string>',
        def: []
      },
      invalid: {
        type: 'Array<string>',
        def: []
      },
      errorMessages: {
        type: 'Object',
        def: {
          generic: {
            type: ['string', 'Function', 'Object', 'null'],
            def: null
          }
        }
      }
    }
  }
});
/**
 * @typedef wordValidatorErrorMessagesType
 * @property {(string|(function(*): string|null)|Object<string,*>|null)} [generic=null] - Generic error message.
 */

/**
 * @typedef wordValidatorOptionsType
 * @property {Array<string>} [valid=[]] - Valid words array.
 * @property {Array<string>} [invalid=[]] - Invalid words array.
 * @property {wordValidatorErrorMessagesType} [errorMessages] - Validation error messages.
 */

/**
 * @description Validates input according to validation options.
 * @param {wordValidatorOptionsType} [options] - Validation options.
 * @returns {{type: 'validator', name: string, messages: Array<string>, plugin: function(string): Object<string,*>}} Validator.
 */

function wordValidator(options) {
  var _wordValidatorSchema$ = wordValidatorSchema.validate({
    options: options
  });

  options = _wordValidatorSchema$.options;
  var utils = new InputValidatorPluginUtils();
  return {
    type: 'validator',
    name: 'wordValidator',
    errorMessages: {
      generic: options.errorMessages.generic
    },

    /**
     * @description Validator.
     * @param {string} value - Input value.
     * @returns {Object<string,*>} - Validation object.
     */
    plugin: function plugin(value) {
      var _context,
          _this = this,
          _context2,
          _context3,
          _context4;

      utils.init(value, null);

      if (_someInstanceProperty(_context = options.valid).call(_context, _bindInstanceProperty(_context2 = function _context2(word) {
        _newArrowCheck(this, _this);

        return value === word;
      }).call(_context2, this))) {
        utils.validate();
      } else if (_someInstanceProperty(_context3 = options.invalid).call(_context3, _bindInstanceProperty(_context4 = function _context4(word) {
        _newArrowCheck(this, _this);

        return value === word;
      }).call(_context4, this))) {
        utils.invalidate();
      }

      return utils.getValidatorOutput();
    }
  };
}

export { wordValidator };